const createVisibilityHandler = (startRecognition, stopRecognition) => {
    const isActiveTabRef = { current: true };
    let hasStartedRecognition = false;

    const setupVisibilityHandling = () => {
        const handlePageOnLoad = () => {
            isActiveTabRef.current = true;
        };

        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                isActiveTabRef.current = true;
                if (hasStartedRecognition) {
                    startRecognition();
                }
            } else {
                isActiveTabRef.current = false;

                if (hasStartedRecognition) {
                    stopRecognition(true, true);
                }
            }
        };

        window.addEventListener('load', handlePageOnLoad);
        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            window.removeEventListener('load', handlePageOnLoad);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    };

    return {
        setupVisibilityHandling,
        isActiveTabRef,
        isActive: () => isActiveTabRef.current,
        setActive: (active) => { isActiveTabRef.current = active; },
        setHasStartedRecognition: (value) => { hasStartedRecognition = value; },
        getHasStartedRecognition: () => hasStartedRecognition
    };
};

export default createVisibilityHandler;
